import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const modulesFiles = require.context('./modules', true, /\.js$/)
const storeKeys = ['state', 'getters', 'mutations', 'actions']
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const value = modulesFiles(modulePath).default
  storeKeys.forEach(key => {
    if (!modules[key]) {
      modules[key] = {}
    }
    let val = value[key] || {}
    Object.assign(modules[key], val)
  })
  return modules
}, {})
export default new Vuex.Store(modules)



// WEBPACK FOOTER //
// ./src/store/index.js